import PropTypes from 'prop-types';

export const Icons = ({ className = '', variant }) => {
  const renderIcon = () => {
    switch (variant) {
      case Icons.MILESTONES: {
        return (
          <svg
            width="17"
            height="16"
            viewBox="0 0 17 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle cx="5.04883" cy="3.66797" r="1" stroke="#FB913A" strokeWidth="1.5" />
            <circle cx="5.04883" cy="8.00195" r="1" stroke="#FB913A" strokeWidth="1.5" />
            <circle cx="5.04883" cy="12.334" r="1" stroke="#FB913A" strokeWidth="1.5" />
            <path
              d="M8.71558 3.66797H13.3822"
              stroke="#FB913A"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M8.71558 8.00195H13.3822"
              stroke="#FB913A"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M8.71558 12.334H13.3822"
              stroke="#FB913A"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        );
      }
      case Icons.TASKS: {
        return (
          <svg
            width="17"
            height="16"
            viewBox="0 0 17 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M3.04761 3.66667L4.04761 4.66667L5.71427 3"
              stroke="#928CDA"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M3.04761 7.66667L4.04761 8.66667L5.71427 7"
              stroke="#928CDA"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M3.04761 11.6667L4.04761 12.6667L5.71427 11"
              stroke="#928CDA"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M8.04761 4H14.0476"
              stroke="#928CDA"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M8.04761 8H14.0476"
              stroke="#928CDA"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M8.04761 12H14.0476"
              stroke="#928CDA"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        );
      }
      case Icons.SHOWINGS: {
        return (
          <svg
            width="17"
            height="16"
            viewBox="0 0 17 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M12.3143 3.19922H5.11431C4.45156 3.19922 3.91431 3.73648 3.91431 4.39922V11.5992C3.91431 12.262 4.45156 12.7992 5.11431 12.7992H12.3143C12.977 12.7992 13.5143 12.262 13.5143 11.5992V4.39922C13.5143 3.73648 12.977 3.19922 12.3143 3.19922Z"
              stroke="#51bfe1"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M11.1143 2.40039V4.00039"
              stroke="#51bfe1"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M6.31445 2.40039V4.00039"
              stroke="#51bfe1"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M3.91431 6.40039H13.5143"
              stroke="#51bfe1"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M7.5144 9.59961L9.9144 9.59961"
              stroke="#51bfe1"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        );
      }
      case Icons.TOURS: {
        return (
          <svg
            width="17"
            height="16"
            viewBox="0 0 17 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M12.3143 3.19922H5.11431C4.45156 3.19922 3.91431 3.73648 3.91431 4.39922V11.5992C3.91431 12.262 4.45156 12.7992 5.11431 12.7992H12.3143C12.977 12.7992 13.5143 12.262 13.5143 11.5992V4.39922C13.5143 3.73648 12.977 3.19922 12.3143 3.19922Z"
              stroke="#4673d1"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M11.1143 2.40039V4.00039"
              stroke="#4673d1"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M6.31445 2.40039V4.00039"
              stroke="#4673d1"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M3.91431 6.40039H13.5143"
              stroke="#4673d1"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M7.5144 9.59961L9.9144 9.59961"
              stroke="#4673d1"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        );
      }
      case Icons.EXPIRING_OFFERS: {
        return (
          <svg
            width="17"
            height="16"
            viewBox="0 0 17 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M12.6675 14.0007H5.33414C4.98052 14.0007 4.64138 13.8602 4.39133 13.6101C4.14129 13.3601 4.00081 13.021 4.00081 12.6673L4.00049 3.33333C4.00049 2.97971 4.14096 2.64057 4.39101 2.39053C4.64106 2.14048 4.9802 2 5.33382 2L10.1721 2C10.7025 2 11.2112 2.21071 11.5863 2.58579L13.4147 4.41425C13.7898 4.7893 14.0005 5.29797 14.0005 5.82838L14.0008 12.6673C14.0008 13.021 13.8603 13.3601 13.6103 13.6101C13.3602 13.8602 13.0211 14.0007 12.6675 14.0007Z"
              stroke="#EC455E"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M10.8005 5.9375C10.8005 5.9375 10.2005 5.25 9.00049 5.25C7.80049 5.25 7.20049 5.9375 7.20049 6.625C7.20049 8.34375 11.0005 7.45 11.0005 9.375C11.0005 10.2 10.3338 10.75 9.00049 10.75C7.66715 10.75 7.00049 9.925 7.00049 9.925"
              stroke="#EC455E"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M9.00049 4.5V11.5"
              stroke="#EC455E"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        );
      }
      case Icons.OFFERS: {
        return (
          <svg
            width="17"
            height="16"
            viewBox="0 0 17 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M12.6675 14.0007H5.33414C4.98052 14.0007 4.64138 13.8602 4.39133 13.6101C4.14129 13.3601 4.00081 13.021 4.00081 12.6673L4.00049 3.33333C4.00049 2.97971 4.14096 2.64057 4.39101 2.39053C4.64106 2.14048 4.9802 2 5.33382 2L10.1721 2C10.7025 2 11.2112 2.21071 11.5863 2.58579L13.4147 4.41425C13.7898 4.7893 14.0005 5.29797 14.0005 5.82838L14.0008 12.6673C14.0008 13.021 13.8603 13.3601 13.6103 13.6101C13.3602 13.8602 13.0211 14.0007 12.6675 14.0007Z"
              stroke="#04A451"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M10.8005 5.9375C10.8005 5.9375 10.2005 5.25 9.00049 5.25C7.80049 5.25 7.20049 5.9375 7.20049 6.625C7.20049 8.34375 11.0005 7.45 11.0005 9.375C11.0005 10.2 10.3338 10.75 9.00049 10.75C7.66715 10.75 7.00049 9.925 7.00049 9.925"
              stroke="#04A451"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M9.00049 4.5V11.5"
              stroke="#04A451"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        );
      }
      case Icons.CLOSING: {
        return (
          <svg
            width="17"
            height="16"
            viewBox="0 0 17 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M4.00098 5H13.001M13.001 5L10.501 2.5M13.001 5L10.501 7.5"
              stroke="#04a451"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M13.001 11H4.00098M4.00098 11L6.50098 8.5M4.00098 11L6.50098 13.5"
              stroke="#04a451"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        );
      }
      case Icons.EXPIRING_LISTINGS: {
        return (
          <svg
            width="17"
            height="16"
            viewBox="0 0 17 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M4.00098 5H13.001M13.001 5L10.501 2.5M13.001 5L10.501 7.5"
              stroke="#FF576D"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M13.001 11H4.00098M4.00098 11L6.50098 8.5M4.00098 11L6.50098 13.5"
              stroke="#FF576D"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        );
      }
      case Icons.PROJECTS: {
        return (
          <svg
            width="17"
            height="16"
            viewBox="0 0 17 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M6.04761 3.33413H5.3439C5.0001 3.33413 4.67039 3.4707 4.42728 3.71381C4.18418 3.95691 4.04761 4.28663 4.04761 4.63043V12.0378C4.04761 12.3816 4.18418 12.7113 4.42728 12.9545C4.67039 13.1976 5.0001 13.3341 5.3439 13.3341L12.0846 13.334C12.4284 13.334 12.7582 13.1974 13.0013 12.9543C13.2444 12.7112 13.3809 12.3815 13.3809 12.0377V4.63028C13.3809 4.28648 13.2444 3.95676 13.0013 3.71366C12.7582 3.47056 12.4284 3.33398 12.0846 3.33398H11.3809"
              stroke="#FB913A"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M9.71444 2H7.71444C6.97806 2 6.3811 2.59695 6.3811 3.33333C6.3811 4.06971 6.97806 4.66667 7.71444 4.66667H9.71444C10.4508 4.66667 11.0478 4.06971 11.0478 3.33333C11.0478 2.59695 10.4508 2 9.71444 2Z"
              stroke="#FB913A"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M7.04761 7.33398H10.3809"
              stroke="#FB913A"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M7.04761 10H10.3809"
              stroke="#FB913A"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        );
      }
      case Icons.EXPIRING_PROJECTS: {
        return (
          <svg
            width="17"
            height="16"
            viewBox="0 0 17 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M6.04761 3.33413H5.3439C5.0001 3.33413 4.67039 3.4707 4.42728 3.71381C4.18418 3.95691 4.04761 4.28663 4.04761 4.63043V12.0378C4.04761 12.3816 4.18418 12.7113 4.42728 12.9545C4.67039 13.1976 5.0001 13.3341 5.3439 13.3341L12.0846 13.334C12.4284 13.334 12.7582 13.1974 13.0013 12.9543C13.2444 12.7112 13.3809 12.3815 13.3809 12.0377V4.63028C13.3809 4.28648 13.2444 3.95676 13.0013 3.71366C12.7582 3.47056 12.4284 3.33398 12.0846 3.33398H11.3809"
              stroke="#FF576D"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M9.71444 2H7.71444C6.97806 2 6.3811 2.59695 6.3811 3.33333C6.3811 4.06971 6.97806 4.66667 7.71444 4.66667H9.71444C10.4508 4.66667 11.0478 4.06971 11.0478 3.33333C11.0478 2.59695 10.4508 2 9.71444 2Z"
              stroke="#FF576D"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M7.04761 7.33398H10.3809"
              stroke="#FF576D"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M7.04761 10H10.3809"
              stroke="#FF576D"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        );
      }
      case Icons.EMPTY_CALENDAR: {
        return (
          <svg
            width="100"
            height="100"
            viewBox="0 0 100 100"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle opacity="0.08" cx="50" cy="50" r="50" fill="#00B152" />
            <path
              d="M68.3339 28.6152H31.6673C28.2922 28.6152 25.5562 31.3513 25.5562 34.7263V71.393C25.5562 74.7681 28.2922 77.5041 31.6673 77.5041H68.3339C71.709 77.5041 74.445 74.7681 74.445 71.393V34.7263C74.445 31.3513 71.709 28.6152 68.3339 28.6152Z"
              fill="white"
              stroke="#B2E8CB"
              strokeWidth="4"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M62.2227 22.5V34.7222"
              stroke="#B2E8CB"
              strokeWidth="4"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M37.7773 22.5V34.7222"
              stroke="#B2E8CB"
              strokeWidth="4"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M25.5562 44.9492H74.445"
              stroke="#B2E8CB"
              strokeWidth="4"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M40.8335 60.1111L46.9446 66.2222L59.1668 54"
              stroke="#B2E8CB"
              strokeWidth="4"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M82.2999 82.9302C82.6986 82.2232 83.729 82.2607 84.0753 82.9947L85.2559 85.4966C85.3443 85.6839 85.4886 85.8391 85.669 85.9408L88.0787 87.2998C88.7856 87.6985 88.7482 88.7289 88.0142 89.0752L85.5123 90.2558C85.325 90.3441 85.1697 90.4885 85.068 90.6689L83.709 93.0785C83.3103 93.7855 82.2799 93.748 81.9336 93.014L80.7531 90.5121C80.6647 90.3248 80.5203 90.1696 80.3399 90.0678L77.9303 88.7089C77.2233 88.3102 77.2608 87.2798 77.9948 86.9335L80.4967 85.7529C80.684 85.6646 80.8392 85.5202 80.941 85.3398L82.2999 82.9302Z"
              fill="white"
              stroke="#B2E8CB"
              strokeWidth="4"
            />
            <path
              d="M19.2054 5.78882C19.5728 5.0651 20.6038 5.0574 20.9819 5.77554L22.926 9.46763C23.0225 9.65089 23.1735 9.79966 23.3582 9.89341L27.0789 11.7821C27.8026 12.1495 27.8103 13.1805 27.0922 13.5586L23.4001 15.5027C23.2168 15.5992 23.0681 15.7502 22.9743 15.9349L21.0856 19.6556C20.7182 20.3793 19.6872 20.387 19.3091 19.6689L17.365 15.9768C17.2685 15.7935 17.1175 15.6448 16.9328 15.551L13.2121 13.6623C12.4884 13.295 12.4807 12.2639 13.1988 11.8858L16.8909 9.94172C17.0742 9.84523 17.223 9.69421 17.3167 9.50953L19.2054 5.78882Z"
              fill="white"
              stroke="#B2E8CB"
              strokeWidth="4"
            />
          </svg>
        );
      }
      case Icons.EMPTY_CALENDAR_2: {
        return (
          <svg
            width="100"
            height="100"
            viewBox="0 0 100 100"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle opacity="0.08" cx="50" cy="50" r="50" fill="#AAABAB" />
            <path
              d="M68.3344 28.6152H31.6678C28.2927 28.6152 25.5566 31.3513 25.5566 34.7263V71.393C25.5566 74.7681 28.2927 77.5041 31.6678 77.5041H68.3344C71.7095 77.5041 74.4455 74.7681 74.4455 71.393V34.7263C74.4455 31.3513 71.7095 28.6152 68.3344 28.6152Z"
              fill="white"
              stroke="#AAABAB"
              strokeWidth="4"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M62.2227 22.5V34.7222"
              stroke="#AAABAB"
              strokeWidth="4"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M37.7773 22.5V34.7222"
              stroke="#AAABAB"
              strokeWidth="4"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M25.5566 44.9492H74.4455"
              stroke="#AAABAB"
              strokeWidth="4"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path d="M39.5 60.5H60.5" stroke="#AAABAB" strokeWidth="4" strokeLinecap="round" />
          </svg>
        );
      }
      case Icons.NAVIGATE: {
        return (
          <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g opacity="0.99">
              <path
                d="M6.5 3H5C3.89543 3 3 3.89543 3 5V11C3 12.1046 3.89543 13 5 13H11C12.1046 13 13 12.1046 13 11V9.5"
                stroke="#FF576D"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M10 3H13V6"
                stroke="#FF576D"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M12.5 3.5L8 8"
                stroke="#FF576D"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </g>
          </svg>
        );
      }
      default:
        return null;
    }
  };

  return (
    <div className={className} style={{ display: 'flex' }}>
      {renderIcon()}
    </div>
  );
};

Icons.MILESTONES = 'milestones';
Icons.TASKS = 'tasks';
Icons.SHOWINGS = 'showings';
Icons.TOURS = 'tours';
Icons.CLOSING = 'closing';
Icons.EXPIRING_OFFERS = 'expiringOffers';
Icons.OFFERS = 'Offers';
Icons.EXPIRING_LISTINGS = 'expiringListings';
Icons.PROJECTS = 'projects';
Icons.EXPIRING_PROJECTS = 'expiringProjects';
Icons.EMPTY_CALENDAR = 'emptyCalendar';
Icons.EMPTY_CALENDAR_2 = 'emptyCalendar2';
Icons.NAVIGATE = 'navigate';
